import * as React from 'react';
import { ELinkOpenMode, FavoritesAssignWidgetContainer as FavoritesAssignWidget } from '@cian/favorites-assign-widget';
import { useDispatch, useSelector } from 'react-redux';

import { EAlertType, requestAuthentication } from '../../actions/authentication';
import { selectRecommendations } from '../../selectors/recommendations';
import { selectIsAuthenticated } from '../../selectors/user';
import { TThunkDispatch } from '../../types/redux';
import { trackSaveToFolder } from './tracking';

export function FavoritesAssignWidgetContainer() {
  const dispatch = useDispatch<TThunkDispatch>();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const recommendations = useSelector(selectRecommendations);
  const [isMounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  const handleWaitForLogin = React.useCallback(() => {
    dispatch(requestAuthentication({ alert: EAlertType.Favorites }));
  }, [dispatch]);

  const handleSaveOffer = React.useCallback(
    (offerId: number) => {
      const recommendationIndex = recommendations.findIndex(recommendation => recommendation.offerId === offerId);
      const position = recommendationIndex >= 0 ? recommendationIndex + 1 : 1;

      trackSaveToFolder(offerId, position);
    },
    [recommendations],
  );

  if (!isMounted) {
    return null;
  }

  return (
    <FavoritesAssignWidget
      disableNotification
      isAuthenticated={isAuthenticated}
      linkOpenMode={ELinkOpenMode.Self}
      onSaveOffer={handleSaveOffer}
      onWaitForLogin={handleWaitForLogin}
    />
  );
}
